import { Box, useMediaQuery, useTheme } from "@mui/material"
import { AdminTopbar } from "../../../Layouts/Drawer/Topbar"
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { AdminSidebar } from "../../../Layouts/Drawer/Sidebar";
import { AdminSideBarDatas } from "../../../utils/data/Private-Pages/data";


export const AdminMain = () => {
    const [drawerOpen, setDrawerOpen] = useState(true);
    const theme = useTheme();
    const containerRef = useRef(null);
    const sideNavRef = useRef(null);
    const [mainContentWidth, setMainContentWidth] = useState('100%');
    const matchDownLG = useMediaQuery(theme.breakpoints.down("lg"));
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const smsc2 = window.innerWidth < 900
    const updateMainContentWidth = () => {
        if (!smsc2) {
            if (containerRef.current && sideNavRef.current) {
                const newWidth = `${containerRef.current.offsetWidth - sideNavRef.current.offsetWidth}px`;
                setMainContentWidth(newWidth);
            }
        } else {
            if (containerRef.current) {
                const newWidth = `${containerRef.current.offsetWidth}px`;
                setMainContentWidth(newWidth);
            }
        }
    };
    useEffect(() => {
        // Initial calculation
        updateMainContentWidth();
        // Add event listener for window resize
        window.addEventListener('resize', updateMainContentWidth);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateMainContentWidth);
        };
    }, [drawerOpen]);
    // useEffect(() => { updateMainContentWidth(); }, [drawerOpen])
    // Handle responsive sidebar collapse
    useEffect(() => {
        if (matchDownLG) {
            setDrawerOpen(false);
        }
    }, [matchDownLG]);

    // Toggle the sidebar
    const toggleDrawer = () => setDrawerOpen(!drawerOpen);
    const isViewPlanPage = location.pathname === "/home/view-plan";
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100vw", overflow: "hidden", }} ref={containerRef}>
            {/* Topbar */}
            {/* <AdminTopbar drawerOpen={drawerOpen} /> */}
            {/* Main Layout */}
            <Box
                sx={{
                    display: "flex",
                    flexGrow: 1,
                    height: "calc(100% - 97px)", // Adjust for Topbar height
                    overflow: "hidden", // Prevent overflow
                    overflow: isViewPlanPage ? "hidden" : "auto",
                }}
            >
                {/* Sidebar */}
                <Box ref={sideNavRef}
                    sx={{
                        width: drawerOpen ? 190 : 60, // Adjust sidebar width dynamically
                        flexShrink: 0,
                        transition: "width 0.3s ease", // Smooth transition
                        overflow: "hidden", // Prevent overflow in the sidebar
                    }}
                >
                    <AdminSidebar
                        toggleDrawer={toggleDrawer}
                        drawerOpen={drawerOpen}
                        setDrawerOpen={setDrawerOpen}
                        sideBarDatas={AdminSideBarDatas}
                    />
                </Box>
                {/* Main Content */}
                {/* <Box
                    component="main"
                    sx={{
                        // flexGrow: 1,
                        height: "100%",
                        width: '100%',
                        // maxWidth: '1300px',
                        maxWidth: mainContentWidth,
                        backgroundColor: "#FFF",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "auto", // Allow scrolling for main content
                    }}> */}
                <Box
                    sx={{
                        display: "flex",
                        height: "calc(100% - 33px)",
                        // width: mainContentWidth,
                        width: '100%',
                        // maxWidth: mainContentWidth,
                        flexDirection: "column",
                        overflow: isViewPlanPage ? "hidden" : "auto", // Handle scrolling
                        padding: isViewPlanPage ? "" : { xs: 1, sm: 1 },
                        // flexGrow: 1, // Ensure the content area grows to fill the space
                    }}
                >
                    <Outlet context={{ drawerOpen: drawerOpen, toggleDrawer: toggleDrawer }} drawerOpen={drawerOpen} />
                    {/* </Box> */}
                </Box>
            </Box>
        </Box>
    )
}